/**
 * Der CSRF-Nachweis für die Sitzungs-Endpunkte.
 *
 * Der Server setzt neben `hm_refresh` ein zweites Cookie `hm_csrf` — dieses
 * **ohne** `HttpOnly`, also lesbar. Wir schicken seinen Wert als `X-CSRF-Token`
 * zurück; der Server vergleicht beide (Double Submit, ADR 0015).
 *
 * Dass der Wert lesbar ist, ist kein Widerspruch zum HttpOnly-Cookie daneben: Er
 * ist kein Geheimnis, sondern der Nachweis, dass die Anfrage aus einer Seite
 * stammt, die das Cookie überhaupt lesen darf. Ein fremder Ursprung kann das
 * nicht — er kann nur ein Formular abschicken.
 */
const CSRF_COOKIE = "hm_csrf";

export function csrfToken(): string | null {
  // Kein Browser (Test, SSR): dann gibt es auch keine Cookies.
  if (typeof document === "undefined") return null;

  for (const entry of document.cookie.split(";")) {
    const separator = entry.indexOf("=");
    if (separator < 0) continue;
    if (entry.slice(0, separator).trim() !== CSRF_COOKIE) continue;
    // Der Wert ist base64url und braucht kein Dekodieren — `decodeURIComponent`
    // steht hier trotzdem, weil ein künftiger Wert Sonderzeichen tragen könnte.
    return decodeURIComponent(entry.slice(separator + 1).trim());
  }

  return null;
}
